module.exports = __webpack_public_path__ + "img/right-link-banner-jp.0397e647.jpg";